/* tslint:disable */
/* eslint-disable */
/**
 * Pitango Market API
 * Canonical public and administrative HTTP API contract.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    ApiErrorEnvelope,
    NotificationsPayloadUpsertPushSubscriptionPayload,
    NotificationsResponseArchiveNotificationResponse,
    NotificationsResponseDeletePushSubscriptionResponse,
    NotificationsResponseGetNotificationsResponse,
    NotificationsResponseGetPushConfigResponse,
    NotificationsResponseMarkNotificationReadResponse,
    NotificationsResponseRestoreNotificationResponse,
    NotificationsResponseUpsertPushSubscriptionResponse,
} from '../models/index';

export interface NotificationsArchiveNotificationRequest {
    notificationId: string;
}

export interface NotificationsDeletePushSubscriptionRequest {
    pushSubscriptionId: string;
}

export interface NotificationsMarkNotificationReadRequest {
    notificationId: string;
}

export interface NotificationsRestoreNotificationRequest {
    notificationId: string;
}

export interface NotificationsUpsertPushSubscriptionRequest {
    notificationsPayloadUpsertPushSubscriptionPayload: NotificationsPayloadUpsertPushSubscriptionPayload;
}

/**
 *
 */
export class NotificationsApi extends runtime.BaseAPI {

    /**
     * Creates request options for notificationsArchiveNotification without sending the request
     */
    async notificationsArchiveNotificationRequestOpts(requestParameters: NotificationsArchiveNotificationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['notificationId'] == null) {
            throw new runtime.RequiredError(
                'notificationId',
                'Required parameter "notificationId" was null or undefined when calling notificationsArchiveNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/notifications/{notificationId}/archive`;
        urlPath = urlPath.replace('{notificationId}', encodeURIComponent(String(requestParameters['notificationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Archive Notification
     */
    async notificationsArchiveNotificationRaw(requestParameters: NotificationsArchiveNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationsResponseArchiveNotificationResponse>> {
        const requestOptions = await this.notificationsArchiveNotificationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Archive Notification
     */
    async notificationsArchiveNotification(requestParameters: NotificationsArchiveNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationsResponseArchiveNotificationResponse> {
        const response = await this.notificationsArchiveNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsDeletePushSubscription without sending the request
     */
    async notificationsDeletePushSubscriptionRequestOpts(requestParameters: NotificationsDeletePushSubscriptionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pushSubscriptionId'] == null) {
            throw new runtime.RequiredError(
                'pushSubscriptionId',
                'Required parameter "pushSubscriptionId" was null or undefined when calling notificationsDeletePushSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/notifications/push-subscriptions/{pushSubscriptionId}`;
        urlPath = urlPath.replace('{pushSubscriptionId}', encodeURIComponent(String(requestParameters['pushSubscriptionId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete Push Subscription
     */
    async notificationsDeletePushSubscriptionRaw(requestParameters: NotificationsDeletePushSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationsResponseDeletePushSubscriptionResponse>> {
        const requestOptions = await this.notificationsDeletePushSubscriptionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete Push Subscription
     */
    async notificationsDeletePushSubscription(requestParameters: NotificationsDeletePushSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationsResponseDeletePushSubscriptionResponse> {
        const response = await this.notificationsDeletePushSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsGetNotifications without sending the request
     */
    async notificationsGetNotificationsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/notifications`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Notifications
     */
    async notificationsGetNotificationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationsResponseGetNotificationsResponse>> {
        const requestOptions = await this.notificationsGetNotificationsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Notifications
     */
    async notificationsGetNotifications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationsResponseGetNotificationsResponse> {
        const response = await this.notificationsGetNotificationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsGetPushConfig without sending the request
     */
    async notificationsGetPushConfigRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/notifications/push-config`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Push Config
     */
    async notificationsGetPushConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationsResponseGetPushConfigResponse>> {
        const requestOptions = await this.notificationsGetPushConfigRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Push Config
     */
    async notificationsGetPushConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationsResponseGetPushConfigResponse> {
        const response = await this.notificationsGetPushConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsMarkNotificationRead without sending the request
     */
    async notificationsMarkNotificationReadRequestOpts(requestParameters: NotificationsMarkNotificationReadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['notificationId'] == null) {
            throw new runtime.RequiredError(
                'notificationId',
                'Required parameter "notificationId" was null or undefined when calling notificationsMarkNotificationRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/notifications/{notificationId}/read`;
        urlPath = urlPath.replace('{notificationId}', encodeURIComponent(String(requestParameters['notificationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Mark Notification Read
     */
    async notificationsMarkNotificationReadRaw(requestParameters: NotificationsMarkNotificationReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationsResponseMarkNotificationReadResponse>> {
        const requestOptions = await this.notificationsMarkNotificationReadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Mark Notification Read
     */
    async notificationsMarkNotificationRead(requestParameters: NotificationsMarkNotificationReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationsResponseMarkNotificationReadResponse> {
        const response = await this.notificationsMarkNotificationReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsRestoreNotification without sending the request
     */
    async notificationsRestoreNotificationRequestOpts(requestParameters: NotificationsRestoreNotificationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['notificationId'] == null) {
            throw new runtime.RequiredError(
                'notificationId',
                'Required parameter "notificationId" was null or undefined when calling notificationsRestoreNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/notifications/{notificationId}/restore`;
        urlPath = urlPath.replace('{notificationId}', encodeURIComponent(String(requestParameters['notificationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Restore Notification
     */
    async notificationsRestoreNotificationRaw(requestParameters: NotificationsRestoreNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationsResponseRestoreNotificationResponse>> {
        const requestOptions = await this.notificationsRestoreNotificationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Restore Notification
     */
    async notificationsRestoreNotification(requestParameters: NotificationsRestoreNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationsResponseRestoreNotificationResponse> {
        const response = await this.notificationsRestoreNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for notificationsUpsertPushSubscription without sending the request
     */
    async notificationsUpsertPushSubscriptionRequestOpts(requestParameters: NotificationsUpsertPushSubscriptionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['notificationsPayloadUpsertPushSubscriptionPayload'] == null) {
            throw new runtime.RequiredError(
                'notificationsPayloadUpsertPushSubscriptionPayload',
                'Required parameter "notificationsPayloadUpsertPushSubscriptionPayload" was null or undefined when calling notificationsUpsertPushSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/notifications/push-subscriptions`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['notificationsPayloadUpsertPushSubscriptionPayload'],
        };
    }

    /**
     * Upsert Push Subscription
     */
    async notificationsUpsertPushSubscriptionRaw(requestParameters: NotificationsUpsertPushSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationsResponseUpsertPushSubscriptionResponse>> {
        const requestOptions = await this.notificationsUpsertPushSubscriptionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Upsert Push Subscription
     */
    async notificationsUpsertPushSubscription(requestParameters: NotificationsUpsertPushSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationsResponseUpsertPushSubscriptionResponse> {
        const response = await this.notificationsUpsertPushSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
